import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Player } from "video-react";
import { AuthState } from "../../reducers/auth";
import { State } from "../../interfaces";

interface Props {
  fileUrl: string;
  fileName?: string;
  poster?: string;
  clssName?: string;
  type: "tag" | "css" | "video";
}

const FileLoader: React.FC<Props> = props => {
  const { fileUrl, fileName, type, poster, clssName } = props;

  const auth: AuthState = useSelector(
    (state: State) => state.auth,
    shallowEqual
  );
  const { accessToken } = auth;

  switch (type) {
    case "video":
      return (
        <Player
          playsInline
          src={`${fileUrl}?access_token=${accessToken}`}
          poster={`${poster}?access_token=${accessToken}`}
          className={clssName}
        />
      );

    case "tag":
      return (
        <img
          alt={fileName}
          width="100%"
          src={`${fileUrl}?access_token=${accessToken}`}
        />
      );
    case "css":
      return (
        <div
          className={clssName}
          style={{
            backgroundImage: `url(${fileUrl}?access_token=${accessToken})`
          }}
        />
      );
  }
};

export default React.memo<Props>(FileLoader);
